import {UserLanguages, LabelTextMessageTypes} from "./Settings";
import type {CallbackNoParamsStringReturn} from "./ui_general/GeneralInterfaces";


/**
 * Defines all texts, labels, and messages displayed in the frontend except feedback messages sent by the
 * backend directly.
 */
export const LabelTextMessages: Record<LabelTextMessageTypes, Record<UserLanguages, CallbackNoParamsStringReturn>> = {
    [LabelTextMessageTypes.HOME]: {
        [UserLanguages.EN]: () => `Home`,
        [UserLanguages.DE]: () => `Startseite`,
        [UserLanguages.ES]: () => `Inicio`,
        [UserLanguages.FR]: () => `Accueil`,
    },
    [LabelTextMessageTypes.TRANSACTION_CREATE_OR_LOAD_CAPTION]: {
        [UserLanguages.EN]: () => `Create or Load Transaction`,
        [UserLanguages.DE]: () => `Transaktion erstellen oder laden`,
        [UserLanguages.ES]: () => `Crear o cargar transacción`,
        [UserLanguages.FR]: () => `Créer ou charger une transaction`,
    },
    [LabelTextMessageTypes.NEW_TRANSACTION_CREATION_TYPE]: {
        [UserLanguages.EN]: () => `TRANSACTION TYPE`,
        [UserLanguages.DE]: () => `Transaktionsart`,
        [UserLanguages.ES]: () => `Tipo de transacción`,
        [UserLanguages.FR]: () => `Type de transaction`,
    },
    [LabelTextMessageTypes.OR]: {
        [UserLanguages.EN]: () => `OR`,
        [UserLanguages.DE]: () => `ODER`,
        [UserLanguages.ES]: () => `O`,
        [UserLanguages.FR]: () => `OU`,
    },
    [LabelTextMessageTypes.CONTACTS]: {
        [UserLanguages.EN]: () => `Contacts`,
        [UserLanguages.DE]: () => `Kontakte`,
        [UserLanguages.ES]: () => `Contactos`,
        [UserLanguages.FR]: () => `Contacts`,
    },
    [LabelTextMessageTypes.LANGUAGE]: {
        [UserLanguages.EN]: () => `Language`,
        [UserLanguages.DE]: () => `Sprache`,
        [UserLanguages.ES]: () => `Idioma`,
        [UserLanguages.FR]: () => `Langue`,
    },
    [LabelTextMessageTypes.ENGLISH]: {
        [UserLanguages.EN]: () => `English`,
        [UserLanguages.DE]: () => `Englisch`,
        [UserLanguages.ES]: () => `Inglés`,
        [UserLanguages.FR]: () => `Anglais`,
    },
    [LabelTextMessageTypes.GERMAN]: {
        [UserLanguages.EN]: () => `German`,
        [UserLanguages.DE]: () => `Deutsch`,
        [UserLanguages.ES]: () => `Alemán`,
        [UserLanguages.FR]: () => `Allemand`,
    },
    [LabelTextMessageTypes.SPANISH]: {
        [UserLanguages.EN]: () => `Spanish`,
        [UserLanguages.DE]: () => `Spanisch`,
        [UserLanguages.ES]: () => `Español`,
        [UserLanguages.FR]: () => `Espagnol`,
    },
    [LabelTextMessageTypes.FRENCH]: {
        [UserLanguages.EN]: () => `French`,
        [UserLanguages.DE]: () => `Französisch`,
        [UserLanguages.ES]: () => `Francés`,
        [UserLanguages.FR]: () => `Français`,
    },
    [LabelTextMessageTypes.UNKNOWN_NETWORK_ERROR]: {
        [UserLanguages.EN]: () => `Unknown Network Error`,
        [UserLanguages.DE]: () => `Unbekannter Netzwerkfehler`,
        [UserLanguages.ES]: () => `Error de red desconocido`,
        [UserLanguages.FR]: () => `Erreur réseau inconnue`,
    },
    [LabelTextMessageTypes.MALFORMED_FETCH_REQUEST]: {
        [UserLanguages.EN]: () => `Malformed Fetch Request`,
        [UserLanguages.DE]: () => `Fehlerhafte Fetch-Anfrage`,
        [UserLanguages.ES]: () => `Solicitud Fetch malformada`,
        [UserLanguages.FR]: () => `Requête Fetch mal formée`,
    },
    [LabelTextMessageTypes.LOGIN]: {
        [UserLanguages.EN]: () => `Log In`,
        [UserLanguages.DE]: () => `Anmelden`,
        [UserLanguages.ES]: () => `Iniciar sesión`,
        [UserLanguages.FR]: () => `Se connecter`,
    },
    [LabelTextMessageTypes.LOGIN_HEADER]: {
        [UserLanguages.EN]: () => `Please provide user login credentials`,
        [UserLanguages.DE]: () => `Bitte geben Sie die Anmeldeinformationen des Benutzers ein`,
        [UserLanguages.ES]: () => `Por favor, proporcione las credenciales de inicio de sesión del usuario`,
        [UserLanguages.FR]: () => `Veuillez fournir les identifiants de connexion de l'utilisateur`,
    },
    [LabelTextMessageTypes.LOGIN_BUTTON_LABEL]: {
        [UserLanguages.EN]: () => `Log In`,
        [UserLanguages.DE]: () => `Anmelden`,
        [UserLanguages.ES]: () => `Iniciar sesión`,
        [UserLanguages.FR]: () => `Se connecter`,
    },
    [LabelTextMessageTypes.LOGIN_SUCCESSFUL]: {
        [UserLanguages.EN]: () => `Login successful`,
        [UserLanguages.DE]: () => `Anmeldung erfolgreich`,
        [UserLanguages.ES]: () => `Inicio de sesión exitoso`,
        [UserLanguages.FR]: () => `Connexion réussie`,
    },
    [LabelTextMessageTypes.CREATE]: {
        [UserLanguages.EN]: () => `Create`,
        [UserLanguages.DE]: () => `Erstellen`,
        [UserLanguages.ES]: () => `Crear`,
        [UserLanguages.FR]: () => `Créer`,
    },
    [LabelTextMessageTypes.YES]: {
        [UserLanguages.EN]: () => `Yes`,
        [UserLanguages.DE]: () => `Ja`,
        [UserLanguages.ES]: () => `Sí`,
        [UserLanguages.FR]: () => `Oui`,
    },
    [LabelTextMessageTypes.NO]: {
        [UserLanguages.EN]: () => `No`,
        [UserLanguages.DE]: () => `Nein`,
        [UserLanguages.ES]: () => `No`,
        [UserLanguages.FR]: () => `Non`,
    },
    [LabelTextMessageTypes.FILE_TYPE]: {
        [UserLanguages.EN]: () => `File Type`,
        [UserLanguages.DE]: () => `Dateityp`,
        [UserLanguages.ES]: () => `Tipo de archivo`,
        [UserLanguages.FR]: () => `Type de fichier`,
    },
    [LabelTextMessageTypes.FILE_SIZE]: {
        [UserLanguages.EN]: () => `File Size`,
        [UserLanguages.DE]: () => `Dateigröße`,
        [UserLanguages.ES]: () => `Tamaño del archivo`,
        [UserLanguages.FR]: () => `Taille du fichier`,
    },
    [LabelTextMessageTypes.TIMESTAMP]: {
        [UserLanguages.EN]: () => `Timestamp`,
        [UserLanguages.DE]: () => `Zeitstempel`,
        [UserLanguages.ES]: () => `Marca de tiempo`,
        [UserLanguages.FR]: () => `Horodatage`,
    },
    [LabelTextMessageTypes.CSV_SEPARATOR]: {
        [UserLanguages.EN]: () => `CSV Separator`,
        [UserLanguages.DE]: () => `CSV-Trennzeichen`,
        [UserLanguages.ES]: () => `Separador CSV`,
        [UserLanguages.FR]: () => `Séparateur CSV`,
    },
    [LabelTextMessageTypes.CSV_DECIMAL_SEPARATOR]: {
        [UserLanguages.EN]: () => `CSV Decimal Separator`,
        [UserLanguages.DE]: () => `CSV-Dezimaltrennzeichen`,
        [UserLanguages.ES]: () => `Separador decimal CSV`,
        [UserLanguages.FR]: () => `Séparateur décimal CSV`,
    },
    [LabelTextMessageTypes.CSV_THOUSAND_SEPARATOR]: {
        [UserLanguages.EN]: () => `CSV Thousand Separator`,
        [UserLanguages.DE]: () => `CSV-Tausendertrennzeichen`,
        [UserLanguages.ES]: () => `Separador de miles CSV`,
        [UserLanguages.FR]: () => `Séparateur de milliers CSV`,
    },
    [LabelTextMessageTypes.CSV_DATE_FORMAT]: {
        [UserLanguages.EN]: () => `CSV Date Format`,
        [UserLanguages.DE]: () => `CSV-Datumsformat`,
        [UserLanguages.ES]: () => `Formato de fecha CSV`,
        [UserLanguages.FR]: () => `Format de date CSV`,
    },
    [LabelTextMessageTypes.CSV_MISSING_PARAMETER_PLACEHOLDERS]: {
        [UserLanguages.EN]: () => `CSV Missing Placeholders`,
        [UserLanguages.DE]: () => `CSV fehlende Platzhalter`,
        [UserLanguages.ES]: () => `Marcadores de posición faltantes en CSV`,
        [UserLanguages.FR]: () => `Placeholders manquants dans le CSV`,
    },
    [LabelTextMessageTypes.COLUMN_HEADERS_INCLUDED]: {
        [UserLanguages.EN]: () => `Column Headers Included`,
        [UserLanguages.DE]: () => `Spaltenüberschriften eingefügt`,
        [UserLanguages.ES]: () => `Encabezados de columna incluidos`,
        [UserLanguages.FR]: () => `En-têtes de colonne inclus`,
    },
    [LabelTextMessageTypes.NAME]: {
        [UserLanguages.EN]: () => `Name`,
        [UserLanguages.DE]: () => `Name`,
        [UserLanguages.ES]: () => `Nombre`,
        [UserLanguages.FR]: () => `Nom`,
    },
    [LabelTextMessageTypes.DESCRIPTION]: {
        [UserLanguages.EN]: () => `Description`,
        [UserLanguages.DE]: () => `Beschreibung`,
        [UserLanguages.ES]: () => `Descripción`,
        [UserLanguages.FR]: () => `Description`,
    },
    [LabelTextMessageTypes.RISK_MODEL_NAME]: {
        [UserLanguages.EN]: () => `Name of Risk Model`,
        [UserLanguages.DE]: () => `Name des Risikomodells`,
        [UserLanguages.ES]: () => `Nombre del modelo de riesgo`,
        [UserLanguages.FR]: () => `Nom du modèle de risque`,
    },
    [LabelTextMessageTypes.ACTIONS]: {
        [UserLanguages.EN]: () => `Actions`,
        [UserLanguages.DE]: () => `Aktionen`,
        [UserLanguages.ES]: () => `Acciones`,
        [UserLanguages.FR]: () => `Actions`,
    },
    [LabelTextMessageTypes.SELECT_ALL]: {
        [UserLanguages.EN]: () => `Select All`,
        [UserLanguages.DE]: () => `Alle auswählen`,
        [UserLanguages.ES]: () => `Seleccionar todo`,
        [UserLanguages.FR]: () => `Tout sélectionner`,
    },
    [LabelTextMessageTypes.UNSELECT_ALL]: {
        [UserLanguages.EN]: () => `Unselect All`,
        [UserLanguages.DE]: () => `Alle abwählen`,
        [UserLanguages.ES]: () => `Deseleccionar todo`,
        [UserLanguages.FR]: () => `Tout désélectionner`,
    },
    [LabelTextMessageTypes.LOAD]: {
        [UserLanguages.EN]: () => `Load`,
        [UserLanguages.DE]: () => `Laden`,
        [UserLanguages.ES]: () => `Cargar`,
        [UserLanguages.FR]: () => `Charger`,
    },
    [LabelTextMessageTypes.DROP_ZONE_HINT]: {
        [UserLanguages.EN]: () => `Drag files here or click to open file browser`,
        [UserLanguages.DE]: () => `Dateien hierher ziehen oder klicken, um den Dateibrowser zu öffnen`,
        [UserLanguages.ES]: () => `Arrastra archivos aquí o haz clic para abrir el explorador de archivos`,
        [UserLanguages.FR]: () => `Déposez des fichiers ici ou cliquez pour ouvrir le navigateur de fichiers`,
    },
    [LabelTextMessageTypes.MORE_DETAILS]: {
        [UserLanguages.EN]: () => `More details`,
        [UserLanguages.DE]: () => `Weitere Details`,
        [UserLanguages.ES]: () => `Más detalles`,
        [UserLanguages.FR]: () => `Plus de détails`,
    },
    [LabelTextMessageTypes.PD_MODEL]: {
        [UserLanguages.EN]: () => `PD Model`,
        [UserLanguages.DE]: () => `PD-Modell`,
        [UserLanguages.ES]: () => `Modelo PD`,
        [UserLanguages.FR]: () => `Modèle PD`,
    },
    [LabelTextMessageTypes.LGD_MODEL]: {
        [UserLanguages.EN]: () => `LGD Model`,
        [UserLanguages.DE]: () => `LGD-Modell`,
        [UserLanguages.ES]: () => `Modelo LGD`,
        [UserLanguages.FR]: () => `Modèle LGD`,
    },
    [LabelTextMessageTypes.CCF_MODEL]: {
        [UserLanguages.EN]: () => `CCF Model`,
        [UserLanguages.DE]: () => `CCF-Modell`,
        [UserLanguages.ES]: () => `Modelo CCF`,
        [UserLanguages.FR]: () => `Modèle CCF`,
    },
    [LabelTextMessageTypes.ANY_MODEL]: {
        [UserLanguages.EN]: () => `Any Model`,
        [UserLanguages.DE]: () => `Beliebiges Modell`,
        [UserLanguages.ES]: () => `Otros modelos`,
        [UserLanguages.FR]: () => `N'importe quel modèle`,
    },
    [LabelTextMessageTypes.ORIG_COLUMN_NAME]: {
        [UserLanguages.EN]: () => `Original Column Name`,
        [UserLanguages.DE]: () => `Originaler Spaltenname`,
        [UserLanguages.ES]: () => `Nombre de columna original`,
        [UserLanguages.FR]: () => `Nom de colonne d'origine`,
    },
    [LabelTextMessageTypes.MAPPED_COLUMN_NAME]: {
        [UserLanguages.EN]: () => `Mapped Column Name`,
        [UserLanguages.DE]: () => `Zugeordneter Spaltenname`,
        [UserLanguages.ES]: () => `Nombre de columna asignado`,
        [UserLanguages.FR]: () => `Nom de colonne mappée`,
    },
    [LabelTextMessageTypes.COLUMN_TYPE]: {
        [UserLanguages.EN]: () => `Column Type`,
        [UserLanguages.DE]: () => `Spaltentyp`,
        [UserLanguages.ES]: () => `Tipo de columna`,
        [UserLanguages.FR]: () => `Type de colonne`,
    },
    [LabelTextMessageTypes.MACHINE_LEARNER_COMPARISON]: {
        [UserLanguages.EN]: () => `Machine Learner Comparison`,
        [UserLanguages.DE]: () => `Maschinelles Lernen Vergleich`,
        [UserLanguages.ES]: () => `Comparación de Aprendizaje Automático`,
        [UserLanguages.FR]: () => `Comparaison des Algorithmes d'Apprentissage Automatique`,
    },
    [LabelTextMessageTypes.BEST_OBSERVED_GINI]: {
        [UserLanguages.EN]: () => `Best Observed Gini Coefficient`,
        [UserLanguages.DE]: () => `Bester beobachteter Gini-Koeffizient`,
        [UserLanguages.ES]: () => `Mejor Coeficiente Gini Observado`,
        [UserLanguages.FR]: () => `Meilleur Coefficient de Gini Observé`,
    },
    [LabelTextMessageTypes.DEGREES_OF_FREEDOM]: {
        [UserLanguages.EN]: () => `Degrees of Freedom`,
        [UserLanguages.DE]: () => `Freiheitsgrade`,
        [UserLanguages.ES]: () => `Grados de Libertad`,
        [UserLanguages.FR]: () => `Degrés de liberté`,
    },
    [LabelTextMessageTypes.GINI_COEFFICIENT]: {
        [UserLanguages.EN]: () => `Gini Coefficient`,
        [UserLanguages.DE]: () => `Gini-Koeffizient`,
        [UserLanguages.ES]: () => `Coeficiente Gini`,
        [UserLanguages.FR]: () => `Coefficient de Gini`,
    },
    [LabelTextMessageTypes.MODEL_PERFORMANCE_VS_COMPLEXITY]: {
        [UserLanguages.EN]: () => `Model Performance vs. Complexity`,
        [UserLanguages.DE]: () => `Modellleistung vs. Komplexität`,
        [UserLanguages.ES]: () => `Rendimiento del modelo vs. Complejidad`,
        [UserLanguages.FR]: () => `Performance du modèle vs. Complexité`,
    },
    [LabelTextMessageTypes.PROGRESS]: {
        [UserLanguages.EN]: () => `Progress`,
        [UserLanguages.DE]: () => `Fortschritt`,
        [UserLanguages.ES]: () => `Progreso`,
        [UserLanguages.FR]: () => `Progrès`,
    },
    [LabelTextMessageTypes.DISTRIBUTION]: {
        [UserLanguages.EN]: () => `Distribution`,
        [UserLanguages.DE]: () => `Verteilung`,
        [UserLanguages.ES]: () => `Distribución`,
        [UserLanguages.FR]: () => `Distribution`,
    },
    [LabelTextMessageTypes.ROC_CURVE]: {
        [UserLanguages.EN]: () => `ROC Curve`,
        [UserLanguages.DE]: () => `ROC-Kurve`,
        [UserLanguages.ES]: () => `Curva ROC`,
        [UserLanguages.FR]: () => `Courbe ROC`,
    },
    [LabelTextMessageTypes.TRUE_POSITIVE_RATE]: {
        [UserLanguages.EN]: () => `True Positive Rate`,
        [UserLanguages.DE]: () => `Richtig-Positiv-Rate`,
        [UserLanguages.ES]: () => `Tasa de Verdaderos Positivos`,
        [UserLanguages.FR]: () => `Taux de Vrais Positifs`,
    },
    [LabelTextMessageTypes.FALSE_POSITIVE_RATE]: {
        [UserLanguages.EN]: () => `False Positive Rate`,
        [UserLanguages.DE]: () => `Falsch-Positiv-Rate`,
        [UserLanguages.ES]: () => `Tasa de Falsos Positivos`,
        [UserLanguages.FR]: () => `Taux de Faux Positifs`,
    },
    [LabelTextMessageTypes.OCCURRENCE_DENSITY]: {
        [UserLanguages.EN]: () => `Occurrence Density`,
        [UserLanguages.DE]: () => `Auftretensdichte`,
        [UserLanguages.ES]: () => `Densidad de ocurrencia`,
        [UserLanguages.FR]: () => `Densité d'occurrence`,
    },
    [LabelTextMessageTypes.CONDITIONAL_PD]: {
        [UserLanguages.EN]: () => `Conditional PD`,
        [UserLanguages.DE]: () => `Bedingte PD`,
        [UserLanguages.ES]: () => `PD Condicional`,
        [UserLanguages.FR]: () => `PD Conditionnelle`,
    },
    [LabelTextMessageTypes.OCCURRENCE_RATE]: {
        [UserLanguages.EN]: () => `Occurrence Rate`,
        [UserLanguages.DE]: () => `Vorkommensrate`,
        [UserLanguages.ES]: () => `Tasa de ocurrencia`,
        [UserLanguages.FR]: () => `Taux d'occurrence`,
    },
    [LabelTextMessageTypes.PROBABILITY_SLASH_RATE]: {
        [UserLanguages.EN]: () => `Probability / Rate`,
        [UserLanguages.DE]: () => `Wahrscheinlichkeit / Rate`,
        [UserLanguages.ES]: () => `Probabilidad / Tasa`,
        [UserLanguages.FR]: () => `Probabilité / Taux`,
    },
    [LabelTextMessageTypes.PROBABILITY_SLASH_DENSITY]: {
        [UserLanguages.EN]: () => `Probability / Density`,
        [UserLanguages.DE]: () => `Wahrscheinlichkeit / Dichte`,
        [UserLanguages.ES]: () => `Probabilidad / Densidad`,
        [UserLanguages.FR]: () => `Probabilité / Densité`,
    },
    [LabelTextMessageTypes.PD_PER_CATEGORY]: {
        [UserLanguages.EN]: () => `PD per Category`,
        [UserLanguages.DE]: () => `PD pro Kategorie`,
        [UserLanguages.ES]: () => `PD por Categoría`,
        [UserLanguages.FR]: () => `PD par Catégorie`,
    },
    [LabelTextMessageTypes.RDS_VARIABLE]: {
        [UserLanguages.EN]: () => `RDS Variable`,
        [UserLanguages.DE]: () => `RDS-Variable`,
        [UserLanguages.ES]: () => `Variable RDS`,
        [UserLanguages.FR]: () => `Variable RDS`,
    },
    [LabelTextMessageTypes.TARGET_VAR_BINARY]: {
        [UserLanguages.EN]: () => `Binary Target`,
        [UserLanguages.DE]: () => `Binäres Ziel`,
        [UserLanguages.ES]: () => `Objetivo Binario`,
        [UserLanguages.FR]: () => `Cible Binaire`,
    },
    [LabelTextMessageTypes.TARGET_VAR_MULTI_CATEGORICAL]: {
        [UserLanguages.EN]: () => `Multi-Categorical Target`,
        [UserLanguages.DE]: () => `Mehrkategorielles Ziel`,
        [UserLanguages.ES]: () => `Objetivo Multi-Categórico`,
        [UserLanguages.FR]: () => `Cible Multi-catégorielle`,
    },
    [LabelTextMessageTypes.TARGET_VAR_NON_NEGATIVE]: {
        [UserLanguages.EN]: () => `Non-Negative Target`,
        [UserLanguages.DE]: () => `Nicht-Negatives Ziel`,
        [UserLanguages.ES]: () => `Objetivo No Negativo`,
        [UserLanguages.FR]: () => `Cible Non-Négative`,
    },
    [LabelTextMessageTypes.TARGET_VAR_UNBOUNDED]: {
        [UserLanguages.EN]: () => `Unbounded Target`,
        [UserLanguages.DE]: () => `Unbeschränktes Ziel`,
        [UserLanguages.ES]: () => `Objetivo Ilimitado`,
        [UserLanguages.FR]: () => `Cible Non Bornée`,
    },
    [LabelTextMessageTypes.INPUT_VAR_NUMERICAL]: {
        [UserLanguages.EN]: () => `Numerical Input`,
        [UserLanguages.DE]: () => `Numerische Eingabe`,
        [UserLanguages.ES]: () => `Entrada Numérica`,
        [UserLanguages.FR]: () => `Entrée Numérique`,
    },
    [LabelTextMessageTypes.INPUT_VAR_CATEGORICAL]: {
        [UserLanguages.EN]: () => `Categorical Input`,
        [UserLanguages.DE]: () => `Kategoriale Eingabe`,
        [UserLanguages.ES]: () => `Entrada Categórica`,
        [UserLanguages.FR]: () => `Entrée Catégorique`,
    },
    [LabelTextMessageTypes.LP_CREATE_OR_LOAD_CAPTION]: {
        [UserLanguages.EN]: () => `Create or Load Model`,
        [UserLanguages.DE]: () => `Modell erstellen oder laden`,
        [UserLanguages.ES]: () => `Crear o cargar modelo`,
        [UserLanguages.FR]: () => `Créer ou charger le modèle`,
    },
    [LabelTextMessageTypes.NEW_TRANSACTION_CREATION_TITLE]: {
        [UserLanguages.EN]: () => `Create new transaction`,
        [UserLanguages.DE]: () => `Neue Transaktion erstellen`,
        [UserLanguages.ES]: () => `Esta opción crea una transacción desde cero`,
        [UserLanguages.FR]: () => `Crear nueva transacción`,
    },
    [LabelTextMessageTypes.NEW_TRANSACTION_CREATION_NAME]: {
        [UserLanguages.EN]: () => `Name`,
        [UserLanguages.DE]: () => `Name`,
        [UserLanguages.ES]: () => `Nombre`,
        [UserLanguages.FR]: () => `Nom`,
    },
    [LabelTextMessageTypes.NEW_TRANSACTION_CREATION_OWNER]: {
        [UserLanguages.EN]: () => `Owner`,
        [UserLanguages.DE]: () => `Eigentümer`,
        [UserLanguages.ES]: () => `Propietario`,
        [UserLanguages.FR]: () => `Propriétaire`,
    },
    [LabelTextMessageTypes.NEW_TRANSACTION_CREATION_DESCRIPTION]: {
        [UserLanguages.EN]: () => `Description`,
        [UserLanguages.DE]: () => `Beschreibung`,
        [UserLanguages.ES]: () => `Descripción`,
        [UserLanguages.FR]: () => `Description`,
    },
    [LabelTextMessageTypes.NEW_TRANSACTION_CREATION_EFFECTIVE_DATE]: {
        [UserLanguages.EN]: () => `Effective Date`,
        [UserLanguages.DE]: () => `Gültigkeitsdatum`,
        [UserLanguages.ES]: () => `Fecha de vigencia`,
        [UserLanguages.FR]: () => `Date d’entrée en vigueur`,
    },
    [LabelTextMessageTypes.NEW_TRANSACTION_CREATION_MATURITY_DATE]: {
        [UserLanguages.EN]: () => `Maturity Date`,
        [UserLanguages.DE]: () => `Fälligkeitstag`,
        [UserLanguages.ES]: () => `Fecha de vencimiento`,
        [UserLanguages.FR]: () => `Date d’échéance`,
    },
    [LabelTextMessageTypes.NEW_TRANSACTION_CREATION_FIRST_PAYMENT]: {
        [UserLanguages.EN]: () => `First Payment`,
        [UserLanguages.DE]: () => `Erste Zahlung`,
        [UserLanguages.ES]: () => `Primer pago`,
        [UserLanguages.FR]: () => `Premier paiement`,
    },
    [LabelTextMessageTypes.NEW_TRANSACTION_CREATION_FREQUENCY]: {
        [UserLanguages.EN]: () => `Frequency`,
        [UserLanguages.DE]: () => `Häufigkeit`,
        [UserLanguages.ES]: () => `Frecuencia`,
        [UserLanguages.FR]: () => `Fréquence`,
    },
    [LabelTextMessageTypes.NEW_TRANSACTION_CREATION_FREQUENCY_MONTHLY]: {
        [UserLanguages.EN]: () => `Monthly`,
        [UserLanguages.DE]: () => `Monatlich`,
        [UserLanguages.ES]: () => `Mensual`,
        [UserLanguages.FR]: () => `Mensuel`,
    },
    [LabelTextMessageTypes.NEW_TRANSACTION_CREATION_FREQUENCY_QUARTERLY]: {
        [UserLanguages.EN]: () => `Quarterly`,
        [UserLanguages.DE]: () => `Vierteljährlich`,
        [UserLanguages.ES]: () => `Trimestral`,
        [UserLanguages.FR]: () => `Trimestriel`,
    },
    [LabelTextMessageTypes.NEW_TRANSACTION_CREATION_FREQUENCY_YEARLY]: {
        [UserLanguages.EN]: () => `Yearly`,
        [UserLanguages.DE]: () => `Jährlich`,
        [UserLanguages.ES]: () => `Anual`,
        [UserLanguages.FR]: () => `Annuel`,
    },
    [LabelTextMessageTypes.SEARCHBAR]: {
        [UserLanguages.EN]: () => `Search transactions...`,
        [UserLanguages.DE]: () => `Transaktionen suchen...`,
        [UserLanguages.ES]: () => `Buscar transacciones...`,
        [UserLanguages.FR]: () => `Rechercher des transactions...`,
    },
    [LabelTextMessageTypes.ALL_FIELDS_REQUIRED]: {
        [UserLanguages.EN]: () => `Please fill in all required fields!`,
        [UserLanguages.DE]: () => `Bitte füllen Sie alle Pflichtfelder aus!`,
        [UserLanguages.ES]: () => `¡Rellene todos los campos obligatorios!`,
        [UserLanguages.FR]: () => `Veuillez remplir tous les champs obligatoires!`,
    },
    [LabelTextMessageTypes.SUCCESSFUL_CREATION]: {
        [UserLanguages.EN]: () => `Transaction successfully created.`,
        [UserLanguages.DE]: () => `Transaktion erfolgreich erstellt.`,
        [UserLanguages.ES]: () => `Transacción creada correctamente.`,
        [UserLanguages.FR]: () => `Transaction créée avec succès.`,
    },
    [LabelTextMessageTypes.WAL]: {
        [UserLanguages.EN]: () => `WAL`,
        [UserLanguages.DE]: () => `WAL`,
        [UserLanguages.ES]: () => `WAL`,
        [UserLanguages.FR]: () => `WAL`,
    },
    [LabelTextMessageTypes.FairValue]: {
        [UserLanguages.EN]: () => `Fair Value`,
        [UserLanguages.DE]: () => `Fair Value`,
        [UserLanguages.ES]: () => `Fair Value`,
        [UserLanguages.FR]: () => `Fair Value`,
    },
    [LabelTextMessageTypes.PD]: {
        [UserLanguages.EN]: () => `PD`,
        [UserLanguages.DE]: () => `PD`,
        [UserLanguages.ES]: () => `PD`,
        [UserLanguages.FR]: () => `PD`,
    },
    [LabelTextMessageTypes.LGD]: {
        [UserLanguages.EN]: () => `LGD`,
        [UserLanguages.DE]: () => `LGD`,
        [UserLanguages.ES]: () => `LGD`,
        [UserLanguages.FR]: () => `LGD`,
    },
    [LabelTextMessageTypes.EL]: {
        [UserLanguages.EN]: () => `EL`,
        [UserLanguages.DE]: () => `EL`,
        [UserLanguages.ES]: () => `EL`,
        [UserLanguages.FR]: () => `EL`,
    },
    [LabelTextMessageTypes.LP_CREATE_OR_LOAD_EXPLANATION]: {
        [UserLanguages.EN]: () => `You can either create a new transaction from scratch or continue working on an
         existing transaction.
         Please indicate your choice by clicking on the respective item ` +
            `below.`,
        [UserLanguages.DE]: () => `Sie können entweder eine neuere Transaktion von Grund auf erstellen oder an 
        einer vorhandenen Transaktion weiterarbeiten. Bitte geben Sie Ihre Wahl an, indem Sie auf ` +
            `den entsprechenden Artikel unten klicken.`,
        [UserLanguages.ES]: () => `Puede crear una nueva transacción desde cero o 
        continuar trabajando en una transacción existente. Indique su elección haciendo clic en el elemento correspondiente a ` +
            `continuación.`,
        [UserLanguages.FR]: () => `Vous pouvez soit créer une nouvelle transaction à partir de zéro, soit 
        continuer à travailler sur une transaction existante. Veuillez indiquer votre choix en cliquant sur ` +
            `l'article correspondant ci-dessous.`,
    },
    [LabelTextMessageTypes.LP_CREATE_PD_MODEL]: {
        [UserLanguages.EN]: () => `Create PD Model`,
        [UserLanguages.DE]: () => `PD-Modell erstellen`,
        [UserLanguages.ES]: () => `Crear modelo de PD`,
        [UserLanguages.FR]: () => `Créer un modèle PD`,
    },
    [LabelTextMessageTypes.LP_CREATE_LGD_MODEL]: {
        [UserLanguages.EN]: () => `Create LGD Model`,
        [UserLanguages.DE]: () => `LGD-Modell erstellen`,
        [UserLanguages.ES]: () => `Crear modelo de LGD`,
        [UserLanguages.FR]: () => `Créer un modèle LGD`,
    },
    [LabelTextMessageTypes.LP_CREATE_CCF_MODEL]: {
        [UserLanguages.EN]: () => `Create CCF Model`,
        [UserLanguages.DE]: () => `CCF-Modell erstellen`,
        [UserLanguages.ES]: () => `Crear modelo de CCF`,
        [UserLanguages.FR]: () => `Créer un modèle CCF`,
    },
    [LabelTextMessageTypes.LP_LOAD_MODEL]: {
        [UserLanguages.EN]: () => `Load Model`,
        [UserLanguages.DE]: () => `Modell laden`,
        [UserLanguages.ES]: () => `Cargar modelo`,
        [UserLanguages.FR]: () => `Charger le modèle`,
    },
    [LabelTextMessageTypes.LP_CREATE_PD_MODEL_EXPLANATION]: {
        [UserLanguages.EN]: () => `This option creates a PD model from scratch based on historic default ` +
            `observations to be uploaded by the user.`,
        [UserLanguages.DE]: () => `Diese Option erstellt ein PD-Modell von Grund auf basierend auf ` +
            `historischen Ausfallbeobachtungen, die vom Benutzer hochgeladen werden sollen.`,
        [UserLanguages.ES]: () => `Esta opción crea un modelo de PD desde cero basado en observaciones ` +
            `históricas de incumplimientos que el usuario debe cargar.`,
        [UserLanguages.FR]: () => `Cette option permet de créer un modèle PD à partir de zéro, basé sur des ` +
            `observations historiques de défauts à télécharger par l'utilisateur.`,
    },
    [LabelTextMessageTypes.LP_CREATE_LGD_MODEL_EXPLANATION]: {
        [UserLanguages.EN]: () => `This option creates an LGD model from scratch based on historic default ` +
            `observations to be uploaded by the user.`,
        [UserLanguages.DE]: () => `Diese Option erstellt ein LGD-Modell von Grund auf basierend auf ` +
            `historischen Ausfallbeobachtungen, die vom Benutzer hochgeladen werden sollen.`,
        [UserLanguages.ES]: () => `Esta opción crea un modelo de LGD desde cero basado en observaciones ` +
            `históricas de incumplimientos que el usuario debe cargar.`,
        [UserLanguages.FR]: () => `Cette option permet de créer un modèle LGD à partir de zéro, basé sur des ` +
            `observations historiques de défauts à télécharger par l'utilisateur.`,
    },
    [LabelTextMessageTypes.LP_CREATE_CCF_MODEL_EXPLANATION]: {
        [UserLanguages.EN]: () => `This option creates a CCF model from scratch based on historic default ` +
            `observations to be uploaded by the user.`,
        [UserLanguages.DE]: () => `Diese Option erstellt ein CCF-Modell von Grund auf basierend auf ` +
            `historischen Ausfallbeobachtungen, die vom Benutzer hochgeladen werden sollen.`,
        [UserLanguages.ES]: () => `Esta opción crea un modelo de CCF desde cero basado en observaciones ` +
            `históricas de incumplimientos que el usuario debe cargar.`,
        [UserLanguages.FR]: () => `Cette option permet de créer un modèle CCF à partir de zéro, basé sur des ` +
            `observations historiques de défauts à télécharger par l'utilisateur.`,
    },
    [LabelTextMessageTypes.LP_LOAD_MODEL_EXPLANATION]: {
        [UserLanguages.EN]: () => `This option loads an existing model allowing to review and/or continue the ` +
            `model building process.`,
        [UserLanguages.DE]: () => `Diese Option lädt ein vorhandenes Modell, um den Modellbildungsprozess zu ` +
            `überprüfen and fortzusetzen.`,
        [UserLanguages.ES]: () => `Esta opción carga un modelo existente que permite revisar y/o continuar el ` +
            `proceso de construcción del modelo.`,
        [UserLanguages.FR]: () => `Cette option charge un modèle existant permettant de revoir et/ou de ` +
            `poursuivre le processus de construction du modèle.`,
    },
    [LabelTextMessageTypes.GENERAL_TAB_CAPTION]: {
        [UserLanguages.EN]: () => `General Information`,
        [UserLanguages.DE]: () => `Allgemeine Informationen`,
        [UserLanguages.ES]: () => `Información general`,
        [UserLanguages.FR]: () => `Informations générales`,
    },
    [LabelTextMessageTypes.GENERAL_TAB_EXPLANATION]: {
        [UserLanguages.EN]: () => `This tab provides an overview of the transaction and its main settings.`,
        [UserLanguages.DE]: () => `Dieser Tab bietet einen Überblick über die Transaktion und ihre Haupteinstellungen.`,
        [UserLanguages.ES]: () => `Esta pestaña proporciona una visión general de la transacción y sus principales configuraciones.`,
        [UserLanguages.FR]: () => `Cet onglet donne un aperçu de la transaction et de ses paramètres principaux.`,
    },
    [LabelTextMessageTypes.LIABILITIES_TAB_CAPTION]: {
        [UserLanguages.EN]: () => `Liabilities`,
        [UserLanguages.DE]: () => `Verbindlichkeiten`,
        [UserLanguages.ES]: () => `Pasivos`,
        [UserLanguages.FR]: () => `Passifs`,
    },
    [LabelTextMessageTypes.LIABILITIES_TAB_EXPLANATION]: {
        [UserLanguages.EN]: () => `View and manage the liabilities of the transaction.`,
        [UserLanguages.DE]: () => `Verwalten Sie die Verbindlichkeiten der Transaktion.`,
        [UserLanguages.ES]: () => `Vea y gestione los pasivos de la transacción.`,
        [UserLanguages.FR]: () => `Gérez les passifs de la transaction.`,
    },
    [LabelTextMessageTypes.ASSETS_TAB_CAPTION]: {
        [UserLanguages.EN]: () => `Assets`,
        [UserLanguages.DE]: () => `Vermögenswerte`,
        [UserLanguages.ES]: () => `Activos`,
        [UserLanguages.FR]: () => `Actifs`,
    },
    [LabelTextMessageTypes.ASSETS_TAB_EXPLANATION]: {
        [UserLanguages.EN]: () => `View and manage the assets underlying the transaction.`,
        [UserLanguages.DE]: () => `Verwalten Sie die zugrunde liegenden Vermögenswerte der Transaktion.`,
        [UserLanguages.ES]: () => `Vea y gestione los activos subyacentes de la transacción.`,
        [UserLanguages.FR]: () => `Gérez les actifs sous-jacents à la transaction.`,
    },
    [LabelTextMessageTypes.TIMESERIES_TAB_CAPTION]: {
        [UserLanguages.EN]: () => `Time Series`,
        [UserLanguages.DE]: () => `Zeitreihen`,
        [UserLanguages.ES]: () => `Series temporales`,
        [UserLanguages.FR]: () => `Séries temporelles`,
    },
    [LabelTextMessageTypes.TIMESERIES_TAB_EXPLANATION]: {
        [UserLanguages.EN]: () => `Inspect and edit time series data relevant to the transaction.`,
        [UserLanguages.DE]: () => `Betrachten und bearbeiten Sie Zeitreihendaten zur Transaktion.`,
        [UserLanguages.ES]: () => `Inspeccione y edite los datos de series temporales relevantes para la transacción.`,
        [UserLanguages.FR]: () => `Consultez et modifiez les séries temporelles liées à la transaction.`,
    },
    [LabelTextMessageTypes.FORMULA_TAB_CAPTION]: {
        [UserLanguages.EN]: () => `Formula`,
        [UserLanguages.DE]: () => `Formel`,
        [UserLanguages.ES]: () => `Fórmula`,
        [UserLanguages.FR]: () => `Formule`,
    },
    [LabelTextMessageTypes.FORMULA_TAB_EXPLANATION]: {
        [UserLanguages.EN]: () => `Define and manage formulas used in the transaction.`,
        [UserLanguages.DE]: () => `Definieren und verwalten Sie Formeln für die Transaktion.`,
        [UserLanguages.ES]: () => `Defina y gestione las fórmulas utilizadas en la transacción.`,
        [UserLanguages.FR]: () => `Définissez et gérez les formules utilisées dans la transaction.`,
    },
    [LabelTextMessageTypes.TRIGGERS_TAB_CAPTION]: {
        [UserLanguages.EN]: () => `Triggers`,
        [UserLanguages.DE]: () => `Trigger`,
        [UserLanguages.ES]: () => `Disparadores`,
        [UserLanguages.FR]: () => `Déclencheurs`,
    },
    [LabelTextMessageTypes.TRIGGERS_TAB_EXPLANATION]: {
        [UserLanguages.EN]: () => `Configure triggers that control transaction logic.`,
        [UserLanguages.DE]: () => `Konfigurieren Sie Trigger, die die Logik der Transaktion steuern.`,
        [UserLanguages.ES]: () => `Configure los disparadores que controlan la lógica de la transacción.`,
        [UserLanguages.FR]: () => `Configurez les déclencheurs qui contrôlent la logique de la transaction.`,
    },
    [LabelTextMessageTypes.WATERFALL_TAB_CAPTION]: {
        [UserLanguages.EN]: () => `Waterfall`,
        [UserLanguages.DE]: () => `Wasserfall`,
        [UserLanguages.ES]: () => `Cascada`,
        [UserLanguages.FR]: () => `Cascade`,
    },
    [LabelTextMessageTypes.WATERFALL_TAB_EXPLANATION]: {
        [UserLanguages.EN]: () => `Design and manage the waterfall structure for payments.`,
        [UserLanguages.DE]: () => `Gestalten und verwalten Sie die Wasserfallstruktur für Zahlungen.`,
        [UserLanguages.ES]: () => `Diseñe y gestione la estructura de cascada para los pagos.`,
        [UserLanguages.FR]: () => `Concevez et gérez la structure de cascade pour les paiements.`,
    },
    [LabelTextMessageTypes.WMT_TAB_CAPTION]: {
        [UserLanguages.EN]: () => `WMT`,
        [UserLanguages.DE]: () => `WMT`,
        [UserLanguages.ES]: () => `WMT`,
        [UserLanguages.FR]: () => `WMT`,
    },
    [LabelTextMessageTypes.WMT_TAB_EXPLANATION]: {
        [UserLanguages.EN]: () => `View and analyze WMT data for the transaction.`,
        [UserLanguages.DE]: () => `Betrachten und analysieren Sie WMT-Daten zur Transaktion.`,
        [UserLanguages.ES]: () => `Vea y analice los datos WMT de la transacción.`,
        [UserLanguages.FR]: () => `Consultez et analysez les données WMT de la transaction.`,
    },
    [LabelTextMessageTypes.TRANSACTION_UPDATED]: {
        [UserLanguages.EN]: () => `Transaction updated successfully.`,
        [UserLanguages.DE]: () => `Transaktion erfolgreich aktualisiert.`,
        [UserLanguages.ES]: () => `Transacción actualizada correctamente.`,
        [UserLanguages.FR]: () => `Transaction mise à jour avec succès.`,
    },
    [LabelTextMessageTypes.UPDATE_TRANSACTION_TITLE]: {
        [UserLanguages.EN]: () => `Update transaction`,
        [UserLanguages.DE]: () => `Transaktion bearbeiten`,
        [UserLanguages.ES]: () => `Actualizar transacción`,
        [UserLanguages.FR]: () => `Mettre à jour la transaction`,
    },
    [LabelTextMessageTypes.AI_CHAT_TAB_CAPTION]: {
        [UserLanguages.EN]: () => `AI Chat`,
        [UserLanguages.DE]: () => `KI-Chat`,
        [UserLanguages.ES]: () => `Chat IA`,
        [UserLanguages.FR]: () => `Chat IA`,
    },
    [LabelTextMessageTypes.AI_CHAT_TAB_EXPLANATION]: {
        [UserLanguages.EN]: () => `Interact with the AI assistant by typing your questions or requests below. Press Enter to send your message. The AI will respond in the chat window.`,
        [UserLanguages.DE]: () => `Interagieren Sie mit dem KI-Assistenten, indem Sie unten Ihre Fragen oder Anfragen eingeben. Drücken Sie Enter, um Ihre Nachricht zu senden. Die KI antwortet im Chatfenster.`,
        [UserLanguages.ES]: () => `Interactúe con el asistente de IA escribiendo sus preguntas o solicitudes abajo. Presione Enter para enviar su mensaje. La IA responderá en la ventana de chat.`,
        [UserLanguages.FR]: () => `Interagissez avec l'assistant IA en tapant vos questions ou demandes ci-dessous. Appuyez sur Entrée pour envoyer votre message. L'IA répondra dans la fenêtre de chat.`,
    },
    [LabelTextMessageTypes.SETTINGS_TAB_CAPTION]: {
        [UserLanguages.EN]: () => `Settings and Preferences`,
        [UserLanguages.DE]: () => `Einstellungen und Präferenzen`,
        [UserLanguages.ES]: () => `Configuración y preferencias`,
        [UserLanguages.FR]: () => `Paramètres et préférences`,
    },
    [LabelTextMessageTypes.SETTINGS_TAB_EXPLANATION]: {
        [UserLanguages.EN]: () => `Configure user preferences, language, and interface options for the securitization design tool.`,
        [UserLanguages.DE]: () => `Konfigurieren Sie Benutzereinstellungen, Sprache und Interface-Optionen für das Verbriefungs-Design-Tool.`,
        [UserLanguages.ES]: () => `Configure las preferencias de usuario, el idioma y las opciones de interfaz para la herramienta de diseño de titulización.`,
        [UserLanguages.FR]: () => `Configurez les préférences utilisateur, la langue et les options d’interface pour l’outil de conception de titrisation.`,
    },
    [LabelTextMessageTypes.NEW_SYNTHETIC_TRANCHE_CREATION_TITLE]: {
        [UserLanguages.EN]: () => "Create Synthetic Tranche",
        [UserLanguages.DE]: () => "Neue synthetische Tranche anlegen",
        [UserLanguages.FR]: () => "Créer une tranche synthétique",
        [UserLanguages.ES]: () => "Crear una tranche sintética"
    },
    [LabelTextMessageTypes.UPDATE_SYNTHETIC_TRANCHE_TITLE]: {
        [UserLanguages.EN]: () => "Update Synthetic Tranche",
        [UserLanguages.DE]: () => "Synthetische Tranche bearbeiten",
        [UserLanguages.FR]: () => "Modifier la tranche synthétique",
        [UserLanguages.ES]: () => "Modificar la tranche sintética"
    },
    [LabelTextMessageTypes.SUBMIT]: {
        [UserLanguages.EN]: () => "Submit",
        [UserLanguages.DE]: () => "Speichern",
        [UserLanguages.FR]: () => "Enregistrer",
        [UserLanguages.ES]: () => "Enviar"
    },
    [LabelTextMessageTypes.CANCEL]: {
        [UserLanguages.EN]: () => "Cancel",
        [UserLanguages.DE]: () => "Abbrechen",
        [UserLanguages.FR]: () => "Annuler",
        [UserLanguages.ES]: () => "Cancelar"
    },
    [LabelTextMessageTypes.UPDATE_SYNTHETIC_EXCESS_SPREAD_TITLE]: {
        [UserLanguages.EN]: () => "Update Synthetic Excess Spread",
        [UserLanguages.DE]: () => "Synthetische Überschussmarge aktualisieren",
        [UserLanguages.FR]: () => "Mettre à jour l'excès de marge synthétique",
        [UserLanguages.ES]: () => "Actualizar el exceso de margen sintético"
    },
    [LabelTextMessageTypes.NEW_SYNTHETIC_EXCESS_SPREAD_CREATION_TITLE]: {
        [UserLanguages.EN]: () => "Create New Synthetic Excess Spread",
        [UserLanguages.DE]: () => "Neue synthetische Überschussmarge erstellen",
        [UserLanguages.FR]: () => "Créer un nouvel excès de marge synthétique",
        [UserLanguages.ES]: () => "Crear nuevo exceso de margen sintético"
    },
    [LabelTextMessageTypes.UPDATE_CASH_RESERVE_TITLE]: {
        [UserLanguages.EN]: () => `Update Cash Reserve`,
        [UserLanguages.DE]: () => `Cash-Reserve bearbeiten`,
        [UserLanguages.ES]: () => `Actualizar reserva de efectivo`,
        [UserLanguages.FR]: () => `Modifier la réserve de trésorerie`,
    },
    [LabelTextMessageTypes.NEW_CASH_RESERVE_CREATION_TITLE]: {
        [UserLanguages.EN]: () => `New Cash Reserve`,
        [UserLanguages.DE]: () => `Neue Cash-Reserve`,
        [UserLanguages.ES]: () => `Nueva reserva de efectivo`,
        [UserLanguages.FR]: () => `Nouvelle réserve de trésorerie`,
    },
    [LabelTextMessageTypes.UPDATE_CASH_TRANCHE_TITLE]: {
        [UserLanguages.EN]: () => `Update Cash Tranche`,
        [UserLanguages.DE]: () => `Cash-Tranche bearbeiten`,
        [UserLanguages.ES]: () => `Actualizar tramo de efectivo`,
        [UserLanguages.FR]: () => `Modifier la tranche de trésorerie`,
    },
    [LabelTextMessageTypes.NEW_CASH_TRANCHE_CREATION_TITLE]: {
        [UserLanguages.EN]: () => `New Cash Tranche`,
        [UserLanguages.DE]: () => `Neue Cash-Tranche`,
        [UserLanguages.ES]: () => `Nuevo tramo de efectivo`,
        [UserLanguages.FR]: () => `Nouvelle tranche de trésorerie`,
    },
    [LabelTextMessageTypes.UPDATE_FEE_TITLE]: {
        [UserLanguages.EN]: () => `Update Fee`,
        [UserLanguages.DE]: () => `Gebühr bearbeiten`,
        [UserLanguages.ES]: () => `Actualizar tarifa`,
        [UserLanguages.FR]: () => `Modifier la redevance`,
    },
    [LabelTextMessageTypes.NEW_FEE_CREATION_TITLE]: {
        [UserLanguages.EN]: () => `New Fee`,
        [UserLanguages.DE]: () => `Neue Gebühr`,
        [UserLanguages.ES]: () => `Nueva tarifa`,
        [UserLanguages.FR]: () => `Nouvelle redevance`,
    },
    [LabelTextMessageTypes.INITIAL_NOMINAL]: {
        [UserLanguages.EN]: () => `Initial Nominal`,
        [UserLanguages.DE]: () => `Anfangsnennwert`,
        [UserLanguages.ES]: () => `Nominal inicial`,
        [UserLanguages.FR]: () => `Nominal initial`,
    },
    [LabelTextMessageTypes.RESERVE_RATE]: {
        [UserLanguages.EN]: () => `Reserve Rate`,
        [UserLanguages.DE]: () => `Reservesatz`,
        [UserLanguages.ES]: () => `Tasa de reserva`,
        [UserLanguages.FR]: () => `Taux de réserve`,
    },
    [LabelTextMessageTypes.SPREAD_RECEIVING]: {
        [UserLanguages.EN]: () => `Spread Receiving`,
        [UserLanguages.DE]: () => `Erhaltener Spread`,
        [UserLanguages.ES]: () => `Spread recibido`,
        [UserLanguages.FR]: () => `Spread reçu`,
    },
    [LabelTextMessageTypes.SPREAD_PAYING]: {
        [UserLanguages.EN]: () => `Spread Paying`,
        [UserLanguages.DE]: () => `Gezahlter Spread`,
        [UserLanguages.ES]: () => `Spread pagado`,
        [UserLanguages.FR]: () => `Spread payé`,
    },
    [LabelTextMessageTypes.BASE_CURVE_ID]: {
        [UserLanguages.EN]: () => `Base Curve`,
        [UserLanguages.DE]: () => `Basiskurve`,
        [UserLanguages.ES]: () => `Curva base`,
        [UserLanguages.FR]: () => `Courbe de base`,
    },
    [LabelTextMessageTypes.TARGET_AMORTIZATION_VARIABLE_ID]: {
        [UserLanguages.EN]: () => `Target Amortization Variable`,
        [UserLanguages.DE]: () => `Amortisierungszielgröße`,
        [UserLanguages.ES]: () => `Variable objetivo de amortización`,
        [UserLanguages.FR]: () => `Variable objectif d’amortissement`,
    },
    [LabelTextMessageTypes.SPREAD]: {
        [UserLanguages.EN]: () => `Spread`,
        [UserLanguages.DE]: () => `Spread`,
        [UserLanguages.ES]: () => `Spread`,
        [UserLanguages.FR]: () => `Spread`,
    },
    [LabelTextMessageTypes.DEFAULT_DEFINITION]: {
        [UserLanguages.EN]: () => `Default Definition`,
        [UserLanguages.DE]: () => `Default-Definition`,
        [UserLanguages.ES]: () => `Definición de default`,
        [UserLanguages.FR]: () => `Définition du défaut`,
    },
    [LabelTextMessageTypes.INVESTED]: {
        [UserLanguages.EN]: () => `Invested`,
        [UserLanguages.DE]: () => `Investiert`,
        [UserLanguages.ES]: () => `Invertido`,
        [UserLanguages.FR]: () => `Investi`,
    },
    [LabelTextMessageTypes.TARGET_RETURN_ON_EQUITY]: {
        [UserLanguages.EN]: () => `Target return on equity`,
        [UserLanguages.DE]: () => `Ziel-Eigenkapitalrendit`,
        [UserLanguages.ES]: () => `Rentabilidad objetivo sobre el capital`,
        [UserLanguages.FR]: () => `Rendement cible des fonds propres`,
    },
    [LabelTextMessageTypes.FIXED_AMOUNT]: {
        [UserLanguages.EN]: () => `Fixed Amount`,
        [UserLanguages.DE]: () => `Fester Betrag`,
        [UserLanguages.ES]: () => `Cantidad fija`,
        [UserLanguages.FR]: () => `Montant fixe`,
    },
    [LabelTextMessageTypes.VARIABLE_RATE]: {
        [UserLanguages.EN]: () => `Variable Rate`,
        [UserLanguages.DE]: () => `Variabler Satz`,
        [UserLanguages.ES]: () => `Tasa variable`,
        [UserLanguages.FR]: () => `Taux variable`,
    },
    [LabelTextMessageTypes.REFERENCE_VARIABLE_ID]: {
        [UserLanguages.EN]: () => `Reference Variable`,
        [UserLanguages.DE]: () => `Referenzvariable`,
        [UserLanguages.ES]: () => `Variable de referencia`,
        [UserLanguages.FR]: () => `Variable de référence`,
    },
    [LabelTextMessageTypes.EXCESS_SPREAD]: {
        [UserLanguages.EN]: () => `Excess Spread`,
        [UserLanguages.DE]: () => `Excess Spread`,
        [UserLanguages.ES]: () => `Spread excedente`,
        [UserLanguages.FR]: () => `Spread excédentaire`,
    },
    [LabelTextMessageTypes.SYNTHETIC_TRANCHE_UPDATED]: {
        [UserLanguages.EN]: () => `Synthetic tranche updated successfully.`,
        [UserLanguages.DE]: () => `Synthetischer Tranchenposten erfolgreich aktualisiert.`,
        [UserLanguages.ES]: () => `Tramo sintético actualizado correctamente.`,
        [UserLanguages.FR]: () => `Tranche synthétique mise à jour avec succès.`,
    },
    [LabelTextMessageTypes.CASH_TRANCHE_UPDATED]: {
        [UserLanguages.EN]: () => `Cash tranche updated successfully.`,
        [UserLanguages.DE]: () => `Cash-Tranche erfolgreich aktualisiert.`,
        [UserLanguages.ES]: () => `Tramo de efectivo actualizado correctamente.`,
        [UserLanguages.FR]: () => `Tranche de trésorerie mise à jour avec succès.`,
    },
    [LabelTextMessageTypes.CASH_RESERVE_UPDATED]: {
        [UserLanguages.EN]: () => `Cash reserve updated successfully.`,
        [UserLanguages.DE]: () => `Bargeldreserve erfolgreich aktualisiert.`,
        [UserLanguages.ES]: () => `Reserva de efectivo actualizada correctamente.`,
        [UserLanguages.FR]: () => `Réserve de trésorerie mise à jour avec succès.`,
    },
    [LabelTextMessageTypes.SYNTHETIC_EXCESS_SPREAD_UPDATED]: {
        [UserLanguages.EN]: () => `Synthetic excess spread updated successfully.`,
        [UserLanguages.DE]: () => `Synthetischer Überschussspread erfolgreich aktualisiert.`,
        [UserLanguages.ES]: () => `Spread sintético de exceso actualizado correctamente.`,
        [UserLanguages.FR]: () => `Spread synthétique excédentaire mis à jour avec succès.`,
    },
    [LabelTextMessageTypes.FEE_UPDATED]: {
        [UserLanguages.EN]: () => `Fee updated successfully.`,
        [UserLanguages.DE]: () => `Gebühr erfolgreich aktualisiert.`,
        [UserLanguages.ES]: () => `Tarifa actualizada correctamente.`,
        [UserLanguages.FR]: () => `Frais mis à jour avec succès.`,
    },
    [LabelTextMessageTypes.TRIGGER_UPDATED]: {
        [UserLanguages.EN]: () => `Trigger updated successfully.`,
        [UserLanguages.DE]: () => `Trigger erfolgreich aktualisiert.`,
        [UserLanguages.ES]: () => `Disparador actualizada correctamente.`,
        [UserLanguages.FR]: () => `Déclencheur mise à jour avec succès.`,
    },
    [LabelTextMessageTypes.TRIGGER_DELETED]: {
        [UserLanguages.EN]: () => `Trigger deleted successfully`,
        [UserLanguages.DE]: () => `Trigger erfolgreich gelöscht`,
        [UserLanguages.ES]: () => `Disparador eliminado correctamente`,
        [UserLanguages.FR]: () => `Déclencheur supprimé avec succès`,
    },
    [LabelTextMessageTypes.INVALID_SCENARIO_NUMBER]: {
        [UserLanguages.EN]: () => `Please use a valid scenario number ranging from zero to the number of simulations.`,
        [UserLanguages.DE]: () => `Bitte verwenden Sie eine gültige Szenariennummer zwischen null und der Anzahl der Simulationen.`,
        [UserLanguages.ES]: () => `Utilice un número de escenario válido comprendido entre cero y el número de simulaciones.`,
        [UserLanguages.FR]: () => `Veuillez utiliser un numéro de scénario valide compris entre zéro et le nombre de simulations.`,
    },
    [LabelTextMessageTypes.SCENARIO_NUMBER]: {
        [UserLanguages.EN]: () => `Scenario number`,
        [UserLanguages.DE]: () => `Szenariennummer`,
        [UserLanguages.ES]: () => `Número de escenario`,
        [UserLanguages.FR]: () => `Numéro de scénario`,
    },
    [LabelTextMessageTypes.PORTFOLIO_UPDATED]: {
        [UserLanguages.EN]: () => `Portfolio updated successfully.`,
        [UserLanguages.DE]: () => `Portfolio erfolgreich aktualisiert.`,
        [UserLanguages.ES]: () => `Portfolio actualizada correctamente.`,
        [UserLanguages.FR]: () => `Portfolio mis à jour avec succès.`,
    },
    [LabelTextMessageTypes.PORTFOLIO_ROW_UPDATED]: {
        [UserLanguages.EN]: () => `Portfolio updated successfully.`,
        [UserLanguages.DE]: () => `Portfolio-Zeile erfolgreich aktualisiert.`,
        [UserLanguages.ES]: () => `Fila de cartera actualizada correctamente.`,
        [UserLanguages.FR]: () => `Ligne du portefeuille mis à jour avec succès.`,
    },
    [LabelTextMessageTypes.PORTFOLIO_CREATED]: {
        [UserLanguages.EN]: () => `Portfolio created successfully.`,
        [UserLanguages.DE]: () => `Portfolio erfolgreich erstellt.`,
        [UserLanguages.ES]: () => `Portafolio creado correctamente.`,
        [UserLanguages.FR]: () => `Portefeuille créé avec succès.`,
    },
    [LabelTextMessageTypes.PORTFOLIO_ROW_CREATED]: {
        [UserLanguages.EN]: () => `Portfolio row created successfully.`,
        [UserLanguages.DE]: () => `Portfolio-Zeile erfolgreich erstellt.`,
        [UserLanguages.ES]: () => `Fila de cartera creado correctamente.`,
        [UserLanguages.FR]: () => `Ligne du portefeuille créé avec succès.`,
    },
    [LabelTextMessageTypes.WATERFALL_ITEM_DELETED]: {
        [UserLanguages.EN]: () => `Waterfall item deleted successfully.`,
        [UserLanguages.DE]: () => `Waterfall-Element erfolgreich gelöscht.`,
        [UserLanguages.ES]: () => `Elemento de waterfall eliminado correctamente.`,
        [UserLanguages.FR]: () => `Élément de waterfall supprimé avec succès.`
    },
    [LabelTextMessageTypes.WATERFALL_DELETED]: {
        [UserLanguages.EN]: () => `Waterfall deleted successfully.`,
        [UserLanguages.DE]: () => `Waterfall erfolgreich gelöscht.`,
        [UserLanguages.ES]: () => `Waterfall eliminado correctamente.`,
        [UserLanguages.FR]: () => `Waterfall supprimé avec succès.`
    },
    [LabelTextMessageTypes.WATERFALL_PAYMENT_PRIORITY_ROW_DELETED]: {
        [UserLanguages.EN]: () => `Waterfall Payment Priority Row deleted successfully.`,
        [UserLanguages.DE]: () => `Waterfall-Zahlungsprioritätszeile erfolgreich gelöscht.`,
        [UserLanguages.ES]: () => `Fila de prioridad de pago del Waterfall eliminada correctamente.`,
        [UserLanguages.FR]: () => `Ligne de priorité de paiement du Waterfall supprimée avec succès.`
    },
    [LabelTextMessageTypes.WATERFALL_AVAILABLE_FUNDS_ROW_DELETED]: {
        [UserLanguages.EN]: () => `Waterfall Available Funds Row deleted successfully.`,
        [UserLanguages.DE]: () => `Waterfall-Zeile für verfügbare Mittel erfolgreich gelöscht.`,
        [UserLanguages.ES]: () => `Fila de fondos disponibles del Waterfall eliminada correctamente.`,
        [UserLanguages.FR]: () => `Ligne de fonds disponibles du Waterfall supprimée avec succès.`
    },
    [LabelTextMessageTypes.TIMESERIES_CREATED]: {
        [UserLanguages.EN]: () => `Time Series created successfully`,
        [UserLanguages.DE]: () => `Zeitreihe erfolgreich erstellt`,
        [UserLanguages.ES]: () => `Serie temporal creada correctamente`,
        [UserLanguages.FR]: () => `Série temporelle créée avec succès`,
    },
    [LabelTextMessageTypes.TIMESERIES_ROW_CREATED]: {
        [UserLanguages.EN]: () => `Time Series Row created successfully`,
        [UserLanguages.DE]: () => `Zeitreihenzeile erfolgreich erstellt`,
        [UserLanguages.ES]: () => `Fila de serie temporal creada correctamente`,
        [UserLanguages.FR]: () => `Ligne de série temporelle créée avec succès`,
    },
    [LabelTextMessageTypes.TIMESERIES_UPDATED]: {
        [UserLanguages.EN]: () => `Time Series updated successfully`,
        [UserLanguages.DE]: () => `Zeitreihe erfolgreich aktualisiert`,
        [UserLanguages.ES]: () => `Serie temporal actualizada correctamente`,
        [UserLanguages.FR]: () => `Série temporelle mise à jour avec succès`,
    },
    [LabelTextMessageTypes.WATERFALL_CREATED]: {
        [UserLanguages.EN]: () => `Waterfall chart created successfully`,
        [UserLanguages.DE]: () => `Wasserfalldiagramm erfolgreich erstellt`,
        [UserLanguages.ES]: () => `Gráfico de cascada creado correctamente`,
        [UserLanguages.FR]: () => `Diagramme en cascade créé avec succès`,
    },
    [LabelTextMessageTypes.TRIGGER_CREATED]: {
        [UserLanguages.EN]: () => `Trigger created successfully`,
        [UserLanguages.DE]: () => `Trigger erfolgreich erstellt`,
        [UserLanguages.ES]: () => `Disparador creado correctamente`,
        [UserLanguages.FR]: () => `Déclencheur créé avec succès`,
    },

    [LabelTextMessageTypes.FORMULA_CREATED]: {
        [UserLanguages.EN]: () => `Formula created successfully`,
        [UserLanguages.DE]: () => `Formel erfolgreich erstellt`,
        [UserLanguages.ES]: () => `Fórmula creada correctamente`,
        [UserLanguages.FR]: () => `Formule créée avec succès`,
    },
    [LabelTextMessageTypes.TIMESERIES_ROW_UPDATED]: {
        [UserLanguages.EN]: () => `Time Series Row updated successfully`,
        [UserLanguages.DE]: () => `Zeitreihenzeile erfolgreich aktualisiert`,
        [UserLanguages.ES]: () => `Fila de serie temporal actualizada correctamente`,
        [UserLanguages.FR]: () => `Ligne de série temporelle mise à jour avec succès`,
    },
    [LabelTextMessageTypes.TIMESERIES_DELETED]: {
        [UserLanguages.EN]: () => `Time series deleted successfully.`,
        [UserLanguages.DE]: () => `Zeitreihe erfolgreich gelöscht.`,
        [UserLanguages.ES]: () => `Serie temporal eliminada correctamente.`,
        [UserLanguages.FR]: () => `Série temporelle supprimée avec succès.`
    },
    [LabelTextMessageTypes.PORTFOLIO_ROW_DELETED]: {
        [UserLanguages.EN]: () => `Portfolio row deleted successfully.`,
        [UserLanguages.DE]: () => `Portfolioreihe erfolgreich gelöscht.`,
        [UserLanguages.ES]: () => `Fila de portafolio eliminada correctamente.`,
        [UserLanguages.FR]: () => `Ligne de portefeuille supprimée avec succès.`,
    },
    [LabelTextMessageTypes.PORTFOLIO_DELETED]: {
        [UserLanguages.EN]: () => `Portfolio deleted successfully.`,
        [UserLanguages.DE]: () => `Portfolio erfolgreich gelöscht.`,
        [UserLanguages.ES]: () => `Portafolio eliminado correctamente.`,
        [UserLanguages.FR]: () => `Portefeuille supprimé avec succès.`,
    },
    [LabelTextMessageTypes.FORMULA_UPDATED]: {
        [UserLanguages.EN]: () => `Formula updated successfully.`,
        [UserLanguages.DE]: () => `Formel erfolgreich aktualisiert.`,
        [UserLanguages.ES]: () => `Fórmula actualizada correctamente.`,
        [UserLanguages.FR]: () => `Formule mise à jour avec succès.`,
    },
    [LabelTextMessageTypes.FORMULA_ROW_UPDATED]: {
        [UserLanguages.EN]: () => `Formula row updated successfully.`,
        [UserLanguages.DE]: () => `Formelzeile erfolgreich aktualisiert.`,
        [UserLanguages.ES]: () => `Fila de fórmula actualizada correctamente.`,
        [UserLanguages.FR]: () => `Ligne de formule mise à jour avec succès.`,
    },
    [LabelTextMessageTypes.FORMULA_DELETED]: {
        [UserLanguages.EN]: () => `Formula deleted successfully.`,
        [UserLanguages.DE]: () => `Formel erfolgreich gelöscht.`,
        [UserLanguages.ES]: () => `Fórmula eliminada correctamente.`,
        [UserLanguages.FR]: () => `Formule supprimée avec succès.`,
    },
    [LabelTextMessageTypes.FORMULA_ROW_DELETED]: {
        [UserLanguages.EN]: () => `Formula row deleted successfully.`,
        [UserLanguages.DE]: () => `Formelzeile erfolgreich gelöscht.`,
        [UserLanguages.ES]: () => `Fila de fórmula eliminada correctamente.`,
        [UserLanguages.FR]: () => `Ligne de formule supprimée avec succès.`,
    },
    [LabelTextMessageTypes.WATERFALL_UPDATED]: {
        [UserLanguages.EN]: () => `Waterfall updated successfully.`,
        [UserLanguages.DE]: () => `Waterfall erfolgreich aktualisiert.`,
        [UserLanguages.ES]: () => `Waterfall actualizada correctamente.`,
        [UserLanguages.FR]: () => `Waterfall mis à jour avec succès.`,
    },
    [LabelTextMessageTypes.NUMBER_OF_SIMULATIONS]: {
        [UserLanguages.EN]: () => `Number of simulations.`,
        [UserLanguages.DE]: () => `Anzahl der Simulationen.`,
        [UserLanguages.ES]: () => `Número de simulaciones.`,
        [UserLanguages.FR]: () => `Nombre de simulations.`
    },
    [LabelTextMessageTypes.DISCOUNTING_CURVE_ID]: {
        [UserLanguages.EN]: () => `Discounting curve.`,
        [UserLanguages.DE]: () => `Abzinsungskurve.`,
        [UserLanguages.ES]: () => `Curva de descuento.`,
        [UserLanguages.FR]: () => `Courbe d’actualisation.`
    },
    [LabelTextMessageTypes.LOSS_DEFINITION]: {
        [UserLanguages.EN]: () => `Loss definitino.`,
        [UserLanguages.DE]: () => `Verlustdefinition.`,
        [UserLanguages.ES]: () => `Definición de pérdida.`,
        [UserLanguages.FR]: () => `Définition de perte.`
    },
    [LabelTextMessageTypes.DAY_COUNT_CONVENTION]: {
        [UserLanguages.EN]: () => `Day count convention.`,
        [UserLanguages.DE]: () => `Day count convention.`,
        [UserLanguages.ES]: () => `Convención de cómputo de días.`,
        [UserLanguages.FR]: () => `Convention de calcul des jours.`
    },
    [LabelTextMessageTypes.RISK_PERCENTILE]: {
        [UserLanguages.EN]: () => `Risk percentile.`,
        [UserLanguages.DE]: () => `Risikoperzentil.`,
        [UserLanguages.ES]: () => `Percentil de riesgo.`,
        [UserLanguages.FR]: () => `Percentile de risque.`
    },
    [LabelTextMessageTypes.NO_TRANSACTION_LOADED]: {
        [UserLanguages.EN]: () => "No transaction loaded.",
        [UserLanguages.DE]: () => "Keine Transaktion geladen.",
        [UserLanguages.ES]: () => "Ninguna transacción cargada.",
        [UserLanguages.FR]: () => "Aucune transaction chargée.",
    },
    [LabelTextMessageTypes.TRANSACTION_SETTINGS_UPDATED]: {
        [UserLanguages.EN]: () => "Transaction settings updated successfully.",
        [UserLanguages.DE]: () => "Transaktionseinstellungen erfolgreich aktualisiert.",
        [UserLanguages.ES]: () => "Configuración de la transacción actualizada correctamente.",
        [UserLanguages.FR]: () => "Paramètres de la transaction mis à jour avec succès.",
    },
    [LabelTextMessageTypes.TRANSACTION_SETTINGS]: {
        [UserLanguages.EN]: () => `Transaction Settings`,
        [UserLanguages.DE]: () => `Transaktionseinstellungen`,
        [UserLanguages.ES]: () => `Configuración de transacción`,
        [UserLanguages.FR]: () => `Paramètres de transaction`,
    },
    [LabelTextMessageTypes.VARIABLE_DROP_REQUIRED_PLACEHOLDER]: {
        [UserLanguages.EN]: () => `Please drop a variable here.`,
        [UserLanguages.DE]: () => `Bitte ziehen Sie hier eine Variable hinein.`,
        [UserLanguages.ES]: () => `Por favor, suelte una variable aquí.`,
        [UserLanguages.FR]: () => `Veuillez déposer une variable ici.`,
    },
    [LabelTextMessageTypes.VARIABLE_DROP_OPTIONAL_PLACEHOLDER]: {
        [UserLanguages.EN]: () => `Drop a variable here.`,
        [UserLanguages.DE]: () => `Ziehen Sie hier eine Variable hinein.`,
        [UserLanguages.ES]: () => `Suelte una variable aquí.`,
        [UserLanguages.FR]: () => `Déposez une variable ici.`,
    },
}
